import { Suspense, lazy, useEffect } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { ThemeProvider } from "@emotion/react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { theme } from "./theme";
import AppError from "components/error/Error";
import BackDrop from "components/backDrop/BackDrop";
import { companyDetails } from 'utils/companyDetails';
import NetworkStatus from "components/NoInternetIndicator/NetworkStatus";
import "assets/styles/Style.scss";
import './index.css';

const AppRouter = lazy(() => import(/* webpackChunkName: "App" */ "./routes/AppRoutes"));

function App() {

  useEffect(() => {
    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.head.appendChild(link);
    }
    link.href = companyDetails?.favicon;
    document.title = companyDetails?.companyName; 
}, []);

  return (
    <ThemeProvider theme={theme}>
      <Suspense fallback={<div className="loading" />}>
        <ErrorBoundary FallbackComponent={AppError}>
          <NetworkStatus>
          <AppRouter />
          <BackDrop />
          <ToastContainer />
          </NetworkStatus>
        </ErrorBoundary>
      </Suspense>
    </ThemeProvider>
  );
}

export default App;
